export default "__VITE_ASSET__CQpNC$fN__"